/* ==========================================================================
   Get Right PC — filter sidebar enhancements (Dawn 15)
   Adds: dual-thumb price slider, "In Stock Only" toggle (desktop sidebar).
   Never submits anything itself — it writes into Dawn's own
   filter.v.price.gte / .lte inputs and fires the event Dawn already listens for.
   Idempotent: safe to re-run after every AJAX facet re-render.
   ========================================================================== */
(function () {
  'use strict';

  /* -------------------------------------------------------------- helpers */

  function clamp(v, lo, hi) {
    if (isNaN(v)) return lo;
    return Math.min(hi, Math.max(lo, v));
  }

  // Pulls the biggest real number out of any price string.
  // Handles "62938.98", "62,938.98", "Rs. 62,938.98", "₹62,938.98", "62.938,98".
  function parsePrice(raw) {
    if (raw === null || raw === undefined) return NaN;
    var s = String(raw).trim();
    if (!s) return NaN;

    // European style: 1.234,56 -> dots are thousands, comma is decimal
    if (/^\D*\d{1,3}(\.\d{3})+(,\d+)?\D*$/.test(s)) {
      s = s.replace(/\./g, '').replace(/,/g, '.');
    } else {
      s = s.replace(/,/g, '');
    }

    var found = s.match(/\d+(?:\.\d+)?/g);
    if (!found || !found.length) return NaN;

    var best = 0;
    for (var i = 0; i < found.length; i++) {
      var n = parseFloat(found[i]);
      if (!isNaN(n) && n > best) best = n;
    }
    return best > 0 ? best : NaN;
  }

  // Finds the ceiling for the slider, trying several sources in order.
  function findMax(scope, gte, lte) {
    var candidates = [gte.getAttribute('max'), lte.getAttribute('max')];

    // fall back to the "The highest price is X" text Dawn prints above the fields
    var host = scope.parentElement;
    if (host) {
      var note =
        host.querySelector('.facets__header-vertical .facets__selected') ||
        host.querySelector('.facets__header .facets__selected') ||
        host.querySelector('.mobile-facets__info');
      if (note) candidates.push(note.textContent);
    }

    for (var i = 0; i < candidates.length; i++) {
      var v = parsePrice(candidates[i]);
      if (!isNaN(v) && v > 0) return Math.ceil(v);
    }
    return NaN;
  }

  /* ---------------------------------------------------------------- price */

  function buildSlider(scope) {
    var gte = scope.querySelector('input[name="filter.v.price.gte"]');
    var lte = scope.querySelector('input[name="filter.v.price.lte"]');
    if (!gte || !lte) return;

    var host = scope.parentElement;
    if (!host) return;

    var prev = scope.previousElementSibling;
    if (prev && prev.classList.contains('grpc-range')) return; // already built

    var max = findMax(scope, gte, lte);
    if (isNaN(max) || max <= 0) {
      if (window.console) {
        console.warn('[grpc-filters] could not read max price; slider skipped', {
          gteMax: gte.getAttribute('max'),
          lteMax: lte.getAttribute('max'),
        });
      }
      return;
    }

    var step = Math.max(1, Math.round(max / 200));
    var minVal = clamp(parsePrice(gte.value) || 0, 0, max);
    var maxVal = clamp(parsePrice(lte.value) || max, 0, max);
    if (isNaN(minVal)) minVal = 0;
    if (isNaN(maxVal) || maxVal <= minVal) maxVal = max;

    var wrap = document.createElement('div');
    wrap.className = 'grpc-range';
    wrap.innerHTML =
      '<div class="grpc-range__track"><div class="grpc-range__fill"></div></div>' +
      '<input type="range" class="grpc-range__min" aria-label="Minimum price">' +
      '<input type="range" class="grpc-range__max" aria-label="Maximum price">';

    var fill = wrap.querySelector('.grpc-range__fill');
    var rMin = wrap.querySelector('.grpc-range__min');
    var rMax = wrap.querySelector('.grpc-range__max');

    [rMin, rMax].forEach(function (r) {
      r.min = 0;
      r.max = max;
      r.step = step;
    });
    rMin.value = minVal;
    rMax.value = maxVal;

    host.insertBefore(wrap, scope);
    paint();

    function paint() {
      var a = parseFloat(rMin.value);
      var b = parseFloat(rMax.value);
      fill.style.left = (a / max) * 100 + '%';
      fill.style.width = ((b - a) / max) * 100 + '%';
    }

    // dragging: update the number fields visually, but don't let Dawn refetch
    rMin.addEventListener('input', function (e) {
      if (parseFloat(rMin.value) > parseFloat(rMax.value) - step) {
        rMin.value = parseFloat(rMax.value) - step;
      }
      gte.value = parseFloat(rMin.value) > 0 ? rMin.value : '';
      paint();
      e.stopPropagation();
    });

    rMax.addEventListener('input', function (e) {
      if (parseFloat(rMax.value) < parseFloat(rMin.value) + step) {
        rMax.value = parseFloat(rMin.value) + step;
      }
      lte.value = parseFloat(rMax.value) < max ? rMax.value : '';
      paint();
      e.stopPropagation();
    });

    // thumb release: hand over to Dawn's normal filtered fetch
    function commit(target) {
      return function (e) {
        e.stopPropagation();
        target.dispatchEvent(new Event('change', { bubbles: true }));
        target.dispatchEvent(new Event('input', { bubbles: true }));
      };
    }
    rMin.addEventListener('change', commit(gte));
    rMax.addEventListener('change', commit(lte));

    // typed value -> slider position
    gte.addEventListener('input', function () {
      var v = parsePrice(gte.value);
      rMin.value = isNaN(v) ? 0 : clamp(v, 0, max);
      paint();
    });
    lte.addEventListener('input', function () {
      var v = parsePrice(lte.value);
      rMax.value = isNaN(v) ? max : clamp(v, 0, max);
      paint();
    });
  }

  function initPrice() {
    var gtes = document.querySelectorAll('input[name="filter.v.price.gte"]');
    for (var i = 0; i < gtes.length; i++) {
      var field = gtes[i].closest('.field');
      var scope =
        gtes[i].closest('price-range') ||
        gtes[i].closest('.facets__price') ||
        (field ? field.parentElement : null);
      if (scope) buildSlider(scope);
    }
  }

  /* --------------------------------------- availability toggle (desktop) */

  function initAvailability() {
    var wrapper = document.getElementById('FacetsWrapperDesktop');
    if (!wrapper) return;

    var inputs = wrapper.querySelectorAll('input[name="filter.v.availability"]');
    for (var i = 0; i < inputs.length; i++) {
      var input = inputs[i];
      var group = input.closest('details.js-filter');
      if (!group) continue;

      if (!group.classList.contains('grpc-availability')) {
        group.classList.add('grpc-availability');
        group.open = true;
      }

      var row = input.closest('li');

      // hide "out of stock" — a single on/off toggle replaces the pair
      if (input.value === '0') {
        if (row) row.classList.add('grpc-hidden-option');
        continue;
      }

      var label = input.closest('label');
      if (!label || label.getAttribute('data-grpc-toggle') === 'on') continue;
      label.setAttribute('data-grpc-toggle', 'on');

      // keep the input, drop Dawn's square/checkmark svgs and the count text
      var kids = Array.prototype.slice.call(label.childNodes);
      for (var k = 0; k < kids.length; k++) {
        if (kids[k] !== input) label.removeChild(kids[k]);
      }
      var span = document.createElement('span');
      span.className = 'grpc-toggle-label';
      span.textContent = 'In Stock Only';
      label.appendChild(span);
      input.setAttribute('aria-label', 'In Stock Only');
    }
  }

  /* ----------------------------------------------------------------- boot */

  var running = false;

  function safely(name, fn) {
    try {
      fn();
    } catch (err) {
      if (window.console) console.warn('[grpc-filters] ' + name + ' failed', err);
    }
  }

  function apply() {
    if (running) return;
    running = true;
    // separate handlers: one failing must never block the other
    safely('availability', initAvailability);
    safely('price', initPrice);
    running = false;
  }

  var timer = null;
  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(apply, 60);
  }

  function watch() {
    var target = document.getElementById('main-collection-filters');
    if (!target || !window.MutationObserver) return;
    new MutationObserver(schedule).observe(target, { childList: true, subtree: true });
  }

  function start() {
    apply();
    watch();
    document.addEventListener('shopify:section:load', schedule);
    window.addEventListener('popstate', schedule);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
